/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentDto } from './DocumentDto';
import type { User } from './User';
export type InstallmentPlanMessageDto = {
    id: string;
    installmentPlanId: string;
    financierId?: string;
    shopId?: string;
    type?: InstallmentPlanMessageDto.type;
    text?: string;
    documentList?: Array<DocumentDto>;
    senderId?: string;
    sender?: User;
    createdAt: string;
};
export namespace InstallmentPlanMessageDto {
    export enum type {
        TEXT = 'TEXT',
        FILE = 'FILE',
        IMAGE = 'IMAGE',
    }
}

